import client from "../../client/api";
import { ClientSession } from "../../client/clientSession";
import CONSTANTS from "../../constants";
import parseErrorClient from "../../utils/parseErrorClient";
import { prepareBody } from "./components/helpers";

export const getFromApi = async ({setLoading, setNotification}) => {
    const user = ClientSession.userTokenPayload
    setLoading(true)
    try{
      const res = await  client.get(`${CONSTANTS.API.PROFILE}/${user.userId}`)
      setLoading(false)
      return res.data
    }catch(error){
      setNotification({ context: 'error', text: parseErrorClient(error) });
      setLoading(false)
    }
  };

  export const savedFromApi = async ({setLoading, data}) => {
    const user = ClientSession.userTokenPayload
    setLoading(true)
      const res = await client.patch(
        `${CONSTANTS.API.PROFILE}/${user.userId}`,
        prepareBody(data))
        setLoading(false)
      return res.data
  };


